// Stripe Checkout / Payment Link URLs per plan. Populated once the live links exist
// (created via the Stripe API against the Navo24 account). Until then, CTAs route to
// /welcome so the page never ships dead buttons.
export const STRIPE_LINKS: Record<string, string> = {
  starter: 'https://buy.stripe.com/6oU28qfp49c5cLw1W9bjW00',
  business: 'https://buy.stripe.com/cNibJ0b8O3RLdPA58lbjW01',
}

export function checkoutHref(plan: string): string {
  return STRIPE_LINKS[plan] || `/welcome?plan=${plan}`
}
